import React from 'react';
import ReusableLoader from "../../components/ReusableLoader/ReusableLoader";
import { Box, Card, CardContent, Container, Stack, Typography } from '@mui/material';
import BackBtn from '../../components/backButton/BackBtn';
import { useLocation } from 'react-router-dom';
import parse from 'html-react-parser';


const JobDescription = () => {
  const location = useLocation();
  const jobData = location?.state;
  // console.log('jobData', jobData?.jobDescription?.description[0]?.description)

  if (!jobData || !jobData?.jobDescription || jobData?.jobDescription?.description?.length === 0) {
    return (
      <Box className="create-candidates-section">
        <Container>
          <Box className="create-candidates">
            <Box className="headingPlusBackBtn">
              <BackBtn />
              <h1 className='formHeadings' >Job Details</h1>
            </Box>
            <Card
              sx={{
                borderRadius: 4,
                boxShadow: "0 12px 28px rgba(50, 30, 60, 0.08)",
                background: "rgba(255, 255, 255, 0.9)",
              }}
            >
              <CardContent>
                <Stack spacing={1.5} alignItems="center">
                  <Typography variant="h6" sx={{ fontWeight: 700 }}>
                    Job description unavailable
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    No job description available
                  </Typography>
                </Stack>
              </CardContent>
            </Card>
          </Box>
        </Container>
      </Box >
    );
  }

  return (
    <Box className="create-candidates-section">
      <Container>
        <Box className="create-candidates">
          <Box className="headingPlusBackBtn">
            <BackBtn />
            <h1 className='formHeadings' >Job Details</h1>
          </Box>
          <Card
            sx={{
              borderRadius: 4,
              boxShadow: "0 12px 28px rgba(50, 30, 60, 0.08)",
              background: "rgba(255, 255, 255, 0.9)",
            }}
          >
            <CardContent>
              <Box className="backgroundStyle">
                {parse(jobData?.jobDescription?.description[0]?.description)}
              </Box>
            </CardContent>
          </Card>
        </Box>
      </Container>
    </Box >
  );
};

export default JobDescription;
